export enum ComparisonOperator {
  'LESS_THAN' = 'LESS_THAN',
  'LESS_THAN_OR_EQUAL' = 'LESS_THAN_OR_EQUAL',
  'EQUAL_TO' = 'EQUAL_TO',
  'GREATER_THAN' = 'GREATER_THAN',
  'GREATER_THAN_OR_EQUAL' = 'GREATER_THAN_OR_EQUAL',
}
